import React, { useState, useEffect } from "react";
import "./index.scss";
import { Grid, Typography } from "@mui/material";
import { getLimitsForUserLoggedIn } from "../../utils/common-apis";
import AppCard from "../../core/cards";
import { getOfflineData } from "../../utils/offline-services";
import RightchoiceLogo from "../../resources/images/Rightchoice.png";
import ZaggleLogo from "../../resources/images/Zaggle.png";
import TerotamLogo from "../../resources/images/Terotam.png";

const ADDITIONAL_RESOURCES = [
  {
    name: "Store Dashboard RightChoice",
    url: "https://dashboard.rightchoice.ai/login?lang=en",
    image: RightchoiceLogo,
  },
  {
    name: "Zaggle EMS",
    url: "https://app.zaggleems.com/",
    image: ZaggleLogo,
  },
  {
    name: "TeroTam",
    url: "https://customer.terotam.com/user/login",
    image: TerotamLogo,
  },
];

const AdminAccess = () => {
  const [listAllowedApps, setAllowedApps] = useState([]);
  useEffect(() => {
    getLimitsForUserLoggedIn((limits) => {
      setAllowedApps(limits);
    });
  }, []);
  const user = getOfflineData("user");
  return (
    <div className="admin-allowed-apps">
      {/* <Typography className="my-access-title" sx={{ marginBottom: 2 }}>
        Dashboard
      </Typography>
      <Typography className="user-intro" sx={{ marginBottom: 2 }}>
        Hi, {user?.name}. Welcome back to Subway!
      </Typography> */}
      <div className="apps-con">
        {listAllowedApps?.length > 0 ? (
          listAllowedApps.map((app) => {
            return (
              <Grid item md={2} sx={{ mb: 5 }}>
                <AppCard appDetails={app} />
              </Grid>
            );
          })
        ) : (
          <h2>No Apps Available</h2>
        )}
      </div>
      <Typography className="my-access-title" sx={{ marginBottom: 2, marginTop: 4 }}>
        Additional Resources
      </Typography>
      <div className="apps-con" style={{ paddingLeft: "20px", gap: "30px" }}>
        <div className="additional-resources-con">
          {ADDITIONAL_RESOURCES.map((link) => (
            <div key={link.name}>
              <a
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <div className="details-con">
                  <div className="app-card">
                    <div className="con-div">
                      <div className="app-logo">
                        <img
                          src={link.image}
                          alt={link.name}
                          className="card-app-image"
                          style={{ width: "45px", height: "45px" }}
                        />
                      </div>
                      <p className="title">{link.name}</p>
                    </div>
                  </div>
                  <div className="app-info"></div>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminAccess;
